var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H6V5H4V6ZM0.5 0V1H9.5V0H0.5ZM2 3.5H8V2.5H2V3.5Z",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-filter.2addab55e5451b3c8056d91787fb0fa2.svg";